/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Expected progress at current module day
 */
export type PaceAnalysisBenchmarkProgressAtCurrentDay = number | null;
